export default __webpack_public_path__ + "static/media/9.f4a7d912.jpg";